import { useEffect, useState } from "react";
import TrainingService from "../Service/TrainingService";
import GetAllArticleView from "../Vue/Pages/GetAllArticleView";
import BlogService from "../Service/BlogService";
import ArticleModel from "../Model/ArticleModel";
import { useParams } from "react-router-dom";
import GetArticleView from "../Vue/Pages/GetArticleView";

const GetArticleController = () => {
    const [articleData, setArticleData] = useState();
    const [loading, setLoading] = useState(true);
    const [formationsData, setFormationsData] = useState();
    const { id } = useParams();

    useEffect(() => {
        fetchArticles();
    }, [])

    const fetchArticles = async () => {
        try {
            let response = await BlogService.fetchArticleById(id);
            let articleModel = new ArticleModel();
            articleModel.id = response.data.id;
            articleModel.title = response.data.title;
            articleModel.content = response.data.content;
            articleModel.date = response.data.date;
            articleModel.images = await Promise.all(response.data.images.map(async (image) => {
                return image.replace('/api/imagess', '/api/images/display'); // Return the constructed article model
            }));
            setArticleData(articleModel); // Set the complete articles array
        } catch (error) {
            console.log("Erreur: " + error);
        } finally {
            try {
                let response = await TrainingService.fetchTrainings();
                let incendieList = [];
                response.data.trainings.slice(0, 3).map(training => {
                  incendieList.push(training);
                });
                setFormationsData(incendieList);
              } catch (error) {
                console.log("erreur" + error);
              } finally {
                setLoading(false); // Set loading to false after fetching data
              }
        }
    }


    return (GetArticleView(formationsData ,articleData, loading))
}

export default GetArticleController;